
class ModalSimple {

	constructor(){  

        this._init();
	}
    

	_init(){
        
        document.addEventListener('DOMContentLoaded', (event) => {

           let target  = document.querySelector('body');
           let myModal = document.querySelector('.contact-content__modal');
           let closeButton = document.querySelector('.close-button');
           let headerPimary = document.querySelector('.header-primary__row');


            closeButton.addEventListener('click', (event)=> closeAll(event) );
            myModal.addEventListener('click', (event)=> closeAll(event) );


            
            function closeAll() {
                myModal.setAttribute('data-state','close');
                target.setAttribute('data-state','unlocked');
                headerPimary.classList.remove('popin')
            }
            function openOnLoad() {
                target.setAttribute('data-state','locked-for-header-primary');
                myModal.setAttribute('data-state','open');
                headerPimary.classList.add('popin')
            }

            document.addEventListener( 'wpcf7mailsent', function( event ) {
                openOnLoad();
            }, false );

	    });
	}




    // var modals = document.querySelectorAll('[data-modal]');


    // modals.forEach(function(trigger) {
    //     trigger.addEventListener('click', function(event) {
    //         event.preventDefault();
    //         var modal = document.getElementById(trigger.dataset.modal);
    //         modal.classList.add('open');
            
    //         var exits = modal.querySelectorAll('.modal-exit');
    //         exits.forEach(function(exit) {
    //             exit.addEventListener('click', function(event) {
    //                 event.preventDefault();
    //                 modal.classList.remove('open');
    //             });
    //         });
    //     });

    //     function open() {            
    //         myModal.classList.add('open');
    //     }

    // });

}

export const modalSimple = new ModalSimple();